import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  isInitializing: true,
  mustChangePassword: false,
  isAdmin: false,
  isSuperAdmin: false,
  canAccessTest: false,
  tenantId: null,
  primaryColor: '#1a1a2e',
  secondaryColor: '#2e75b6',
  logoUrl: null,
  portalTitle: 'Avixa Portal',
  faviconUrl: null,
  textColor: '#ffffff',
  fontBold: false,
  fontItalic: false,
  fontSize: null,
  isTestMode: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initUser: (state, action) => {
      const p = action.payload;
      state.user               = p;
      state.isAuthenticated    = true;
      state.isInitializing     = false;
      state.mustChangePassword = p.mustChangePassword || false;
      state.isAdmin            = p.isAdmin || false;
      state.isSuperAdmin       = p.isSuperAdmin || false;
      state.canAccessTest      = p.canAccessTest || false;
      state.tenantId           = p.tenantId || null;
      state.primaryColor       = p.primaryColor || '#1a1a2e';
      state.secondaryColor     = p.secondaryColor || '#2e75b6';
      state.logoUrl            = p.logoUrl || null;
      state.portalTitle        = p.portalTitle || 'Avixa Portal';
      state.faviconUrl         = p.faviconUrl || null;
      state.textColor          = p.textColor || '#ffffff';
      state.fontBold           = p.fontBold || false;
      state.fontItalic         = p.fontItalic || false;
      state.fontSize           = p.fontSize || null;
      state.error              = null;
    },
    logout: (state) => {
      state.user               = null;
      state.isAuthenticated    = false;
      state.isInitializing     = false;
      state.mustChangePassword = false;
      state.isAdmin            = false;
      state.isSuperAdmin       = false;
      state.canAccessTest      = false;
      state.tenantId           = null;
      state.primaryColor       = '#1a1a2e';
      state.secondaryColor     = '#2e75b6';
      state.logoUrl            = null;
      state.portalTitle        = 'Avixa Portal';
      state.faviconUrl         = null;
      state.textColor          = '#ffffff';
      state.fontBold           = false;
      state.fontItalic         = false;
      state.fontSize           = null;
      state.isTestMode         = false;
    },
    toggleTestMode: (state) => {
      state.isTestMode = !state.isTestMode;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { initUser, logout, setLoading, setError, clearError, toggleTestMode } = authSlice.actions;
export default authSlice.reducer;
